export default __webpack_public_path__ + "static/media/About-Tower-viajes-3@3x.a7f16ac5.jpg";